import React, { useEffect, useState } from "react";
import FullRouter from "./RouterPath/index";
import "bootstrap/dist/css/bootstrap.min.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./App.css";
import "./Assets/style/style.css";
import { BrowserRouter } from "react-router-dom"; // Keep BrowserRouter only here
import { SessionExpiredDialog } from "./Components/SessionExpiredDialog";
import { GoogleOAuthProvider } from "@react-oauth/google";

const GOOGLE_CLIENT_ID = "393877425666-o8ddqc94htm7q047r1m8j06n3v62v2m3.apps.googleusercontent.com";

const theme = createTheme();

function App() {
  const [sessionExpiredOpen, setSessionExpiredOpen] = useState(false);
  const [sessionExpiredMessage, setSessionExpiredMessage] = useState("");

  useEffect(() => {
    const onSessionExpired = (event) => {
      const message = event?.detail?.message || "Session expired. Please login again.";
      setSessionExpiredMessage(message);
      setSessionExpiredOpen(true);
    };

    window.addEventListener("session-expired", onSessionExpired);
    return () => {
      window.removeEventListener("session-expired", onSessionExpired);
    };
  }, []);

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <ThemeProvider theme={theme}>
        <>
          <div>
            <BrowserRouter>
              <FullRouter />
            </BrowserRouter>
          </div>
          <SessionExpiredDialog
            open={sessionExpiredOpen}
            onClose={() => {
              setSessionExpiredOpen(false);
              localStorage.clear();
              window.location.href = "/";
            }}
            message={sessionExpiredMessage}
          />
        </>
      </ThemeProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
